import fetch from '../../../../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'
import ApiService from '@/utils/ApiService'

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export const retrieve = ({ commit }, id) => {
  commit(types.TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.SET_ERROR, e.message)
    })
}

export const update = async ({ commit, state }, data) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LOADING)
  const response = await new ApiService(data['@id']).put(data)
  commit(types.TOGGLE_LOADING)
  if (response.status < 300) {
    commit(types.SET_UPDATED, response.json)
  } else {
    commit(types.SET_VIOLATIONS, response)
  }
}

export const updateRetrieved = ({ commit }, updated) => {
  commit(types.UPDATE_RETRIEVED, updated)
}
